import { render, staticRenderFns } from "./EdgeStack.vue?vue&type=template&id=1ef8d6ba&scoped=true"
import script from "./EdgeStack.vue?vue&type=script&lang=js"
export * from "./EdgeStack.vue?vue&type=script&lang=js"
import style0 from "./EdgeStack.vue?vue&type=style&index=0&id=1ef8d6ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef8d6ba",
  null
  
)

export default component.exports